import { CascaderOptionType } from 'antd/lib/cascader'
import { Country } from '../../types'

export enum ReportTab {
  MeetingReport = 'meeting-report',
  BigReport = 'big-report',
  PyramidReport = 'pyramid-report',
  RankingReport = 'ranking-report',
}

export interface ReportStoreState {
  storeInitialized: boolean
  activeTab: ReportTab | undefined
  countries: string[]
  mappedCountries: CascaderOptionType[]
  selectedCountry: CascaderOptionType

  initStore: (countries: Country[], activeTab: ReportTab, countriesWhereReportGenerationIsEnabled: Country[] | undefined) => void
  setActiveTab: (activeTab: ReportTab) => void
  setSelectedCountry: (country: string) => void
  setMappedCountries: (options: CascaderOptionType[]) => void
}
